import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { ErrorBoundary, Propbar } from '@sainsburys-tech/bolt'
import { agnostify } from '@sainsburys-tech/boltui-utils'
import LazyHydrate from 'react-lazy-hydration'
import styled from 'styled-components'

import { loadHomepageData } from '../../actions/homepageAppActions'
import HomepageComponents from '../../components/HomepageComponents/HomepageComponents'
import AppPrompt from '../../components/AppPrompt/AppPrompt'
import ArgosCardPrompt from '../../components/ArgosCardPrompt/ArgosCardPrompt'
import EmailForm from '../../components/EmailForm/EmailForm'
import StoreLocator from '../../components/StoreLocator/StoreLocator'
import Recommendations from '../../components/Recommendations/Recommendations'
import FeaturedProducts from '../../components/FeaturedProducts/FeaturedProducts'
import PageNotFoundWrapper from '../../components/PageNotFoundWrapper/PageNotFoundWrapper'
import SeoHomepage from '../../components/SeoHomepage/SeoHomepage'
import { propbarRoutes, validAjaxLink } from '../../helpers/ContentHelper'

const PropbarContainer = styled.div`
  margin: 15px;
`
export class HomepageContainer extends Component {
  constructor(props) {
    super(props)
    this.onCmsClick = this.onCmsClick.bind(this)
  }

  componentDidMount() {
    const { homepageData, historyData } = this.props
    if (!homepageData.data) this.props.loadHomepageData({ resetData: true, historyData })
  }

  componentDidUpdate(prevProps) {
    const { history, historyData } = this.props

    if (history.location.pathname !== prevProps.location.pathname) {
      this.props.loadHomepageData({ resetData: true, historyData })
    }
  }

  onCmsClick(event, linkUrl) {
    if (!linkUrl || !linkUrl.includes('argos.co.uk')) return
    const ajaxLinkUrl = validAjaxLink(linkUrl)
    if (ajaxLinkUrl) {
      event.preventDefault()
      this.props.history.push(ajaxLinkUrl)
    } else window.location.href = agnostify(linkUrl)
  }

  render() {
    const { homepageData, history } = this.props
    const isHomepage404 = !homepageData
    if (isHomepage404) return <PageNotFoundWrapper />

    const route = (path) => history && history.push(path)

    return (
      <>
        <h1 className='sr-only'>Argos Homepage</h1>
        <LazyHydrate whenIdle>
          <Fragment>
            <ErrorBoundary>
              <PropbarContainer>
                <Propbar routes={propbarRoutes(route)} />
              </PropbarContainer>
            </ErrorBoundary>

            <ErrorBoundary>
              <HomepageComponents
                homepageData={homepageData}
                isResettingData={homepageData && homepageData.resettingData}
                onCmsClick={this.onCmsClick}
              />
            </ErrorBoundary>
          </Fragment>
        </LazyHydrate>

        <LazyHydrate whenIdle>
          <Fragment>
            <ErrorBoundary>
              <FeaturedProducts />
            </ErrorBoundary>

            <ErrorBoundary>
              <EmailForm />
            </ErrorBoundary>
            <ErrorBoundary>
              <ArgosCardPrompt onCmsClick={this.onCmsClick} />
            </ErrorBoundary>
          </Fragment>
        </LazyHydrate>

        <LazyHydrate whenIdle>
          <ErrorBoundary>
            <AppPrompt />
          </ErrorBoundary>
        </LazyHydrate>

        <LazyHydrate whenIdle>
          <ErrorBoundary>
            <Recommendations />
          </ErrorBoundary>
        </LazyHydrate>

        <LazyHydrate whenVisible>
          <Fragment>
            <ErrorBoundary>
              <StoreLocator />
            </ErrorBoundary>
          </Fragment>
        </LazyHydrate>

        <LazyHydrate ssrOnly>
          <SeoHomepage seoFooter={homepageData.meta && homepageData.meta.seoFooter} />
        </LazyHydrate>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  homepageData: state?.homepageApp?.homepageData,
  historyData: state?.homepageApp?.historyData,
})

const mapDispatchToProps = (dispatch) => ({
  loadHomepageData: (params) => dispatch(loadHomepageData(params)),
  push,
})

HomepageContainer.propTypes = {
  homepageData: PropTypes.arrayOf(PropTypes.object),
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomepageContainer)
